import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
	<footer id="footer" className="footer-experience footer-experience--minimal" role="contentinfo">
		<div className="container">
			<div className="footer-minimal">
				<Link to="/" className="footer-logo text-decoration-none">
					<strong>Visit All Nepal</strong>
				</Link>
				<nav className="footer-minimal__links" aria-label="Footer">
					<Link to="/journeys">Journeys</Link>
					<Link to="/flights">Domestic flights</Link>
					<Link to="/guides">Travel Guide</Link>
					<Link to="/festivals">Festivals</Link>
					<a href="/#places">Places</a>
					<Link to="/about">About</Link>
					<Link to="/support">Support</Link>
					<Link to="/privacy">Privacy</Link>
					<Link to="/terms">Terms</Link>
				</nav>
				<p className="footer-minimal__copy text-muted small mb-0">
					&copy; {new Date().getFullYear()} Visit All Nepal · Nepal travel guides &amp; booking
				</p>
			</div>
		</div>
	</footer>
);

export default Footer;
